__turbopack_context__.v({
  "empty": "RatingStarDisplay-module__X6Ns7a__empty",
  "filled": "RatingStarDisplay-module__X6Ns7a__filled",
  "half": "RatingStarDisplay-module__X6Ns7a__half",
  "ratingLabel": "RatingStarDisplay-module__X6Ns7a__ratingLabel",
  "star": "RatingStarDisplay-module__X6Ns7a__star",
  "stars": "RatingStarDisplay-module__X6Ns7a__stars",
});
